<template>
  <section :class="$style.container">
    <EmojisCarousel
      :title="$t('general.team_a')"
      :items="emojisForTeamA"
      :active-item="teamAEmoji"
      @onChange="handleSetTeamAEmoji"
    />
    <EmojisCarousel
      :title="$t('general.team_b')"
      :items="emojisForTeamB"
      :active-item="teamBEmoji"
      @onChange="handleSetTeamBEmoji"
    />
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { emojisForTeamA, emojisForTeamB } from '@/consts';
import EmojisCarousel from '@/components/EmojisCarousel/EmojisCarousel';

export default {
  components: {
    EmojisCarousel,
  },
  data() {
    return {
      emojisForTeamA,
      emojisForTeamB,
    };
  },
  computed: {
    ...mapState('settings', ['teamAEmoji', 'teamBEmoji']),
  },
  methods: {
    ...mapMutations('settings', ['setTeamAEmoji', 'setTeamBEmoji']),

    handleSetTeamAEmoji(emoji) {
      this.$_playSound();
      this.setTeamAEmoji(emoji);
    },

    handleSetTeamBEmoji(emoji) {
      this.$_playSound();
      this.setTeamBEmoji(emoji);
    },
  },
};
</script>

<style module lang="scss">
  .container {
    overflow: hidden;
    margin-top: 15px;
    flex: 1;
  }
</style>
